import styled, { createGlobalStyle } from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const IMAGE_AR_OVERLAY_CLASS = 'image-aspect-ratio-overlay'

export const ImageAspectRatioOverlayStyles = createGlobalStyle`
  .${IMAGE_AR_OVERLAY_CLASS} {
    min-width: 275px;
  }
`

export const DropdownListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  min-width: 0;
`

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  padding: 6px 8px;
  height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border-radius: ${RADII.item};
  box-sizing: border-box;
  white-space: nowrap;
  background: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryLight : COLORS.white};
  border: ${({ $isSelected }) =>
    $isSelected ? `1px solid ${COLORS.borderColor}` : '1px solid transparent'};
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: ${COLORS.primaryLight};
  }
`

export const ItemLeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const ItemCredits = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 4px;
`

export const TooltipTrigger = styled.div`
  display: flex;
`
